// Core Imports
import GraniteError from 'granite-admin/utils/granite-error';
import graniteAPIClient from 'granite-admin/utils/granite-client';
const url = process.env.REACT_APP_ORGANISATION_BASE_URL;
async function getLogoTheme(params) {
  try {
    const {
      data
    } = await graniteAPIClient(url).get('/theme/set/', {
      params: {
        ...params
      }
    });
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function saveLogoTheme(payload) {
  try {
    const response = await graniteAPIClient(url).post('/theme/set/', payload);
    return response.data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function deleteLogoTheme(themePk) {
  try {
    const {
      data
    } = await graniteAPIClient(url).put('/theme/reset/');
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
export default {
  getLogoTheme,
  saveLogoTheme,
  deleteLogoTheme
};